export default {"src":"/login-app/[GIT_HASH]/_next/static/media/group_by.4ac47312.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};